import "./About.module.css";
import GlobalHeader from "@/reusable_sections/Header";
import OurLegacy from "./sections/OurLegacy";
import LeadershipPhilosophy from "./sections/LeadershipPhilosophy";
import StrategicVision from "./sections/StrategicVision";
import AboutMe from "./sections/AboutMe";
import InstitutionalFooter from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <GlobalHeader />
      <OurLegacy />
      <LeadershipPhilosophy />
      <StrategicVision />
      <AboutMe />
      <InstitutionalFooter />
    </div>;
}